import { supabase, normalizeError } from '@/lib/supabaseClient'

export async function inviteDeveloper({ email, fullName, companyName, phone }) {
  try {
    const { data, error } = await supabase.rpc('admin_create_developer', {
      p_email: email,
      p_full_name: fullName,
      p_company_name: companyName,
      p_phone: phone,
      p_send_invitation: true
    })

    if (error) throw error
    return { data, error: null }
  } catch (error) {
    return { data: null, error: normalizeError(error) }
  }
}

export async function getAllDevelopers() {
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('role', 'developer')
      .order('created_at', { ascending: false })

    if (error) throw error
    return { data, error: null }
  } catch (error) {
    return { data: null, error: normalizeError(error) }
  }
}

export async function getDeveloperWithProjects(developerId) {
  try {
    const { data, error } = await supabase.rpc('admin_get_developer_with_projects', {
      p_developer_id: developerId
    })

    if (error) throw error
    return { data, error: null }
  } catch (error) {
    return { data: null, error: normalizeError(error) }
  }
}

export async function getDeveloperInvitations() {
  try {
    const { data, error } = await supabase
      .from('developer_invitations')
      .select(`
        *,
        invited_by_profile:profiles!invited_by(
          full_name,
          email
        ),
        developer_profile:profiles!developer_id(
          full_name,
          email
        )
      `)
      .order('created_at', { ascending: false })

    if (error) throw error
    return { data, error: null }
  } catch (error) {
    return { data: null, error: normalizeError(error) }
  }
}

export async function cancelDeveloperInvitation(invitationId) {
  try {
    const { error } = await supabase
      .from('developer_invitations')
      .update({ status: 'cancelled', updated_at: new Date().toISOString() })
      .eq('id', invitationId)

    if (error) throw error
    return { error: null }
  } catch (error) {
    return { error: normalizeError(error) }
  }
}

export async function resendDeveloperInvitation(invitationId) {
  try {
    const { error } = await supabase
      .from('developer_invitations')
      .update({
        expires_at: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
        updated_at: new Date().toISOString()
      })
      .eq('id', invitationId)

    if (error) throw error
    return { error: null }
  } catch (error) {
    return { error: normalizeError(error) }
  }
}

export async function createProjectForDeveloper({
  developerId,
  title,
  description,
  location,
  address,
  status = 'draft'
}) {
  try {
    const { data, error } = await supabase.rpc('admin_create_project_for_developer', {
      p_developer_id: developerId,
      p_title: title,
      p_description: description,
      p_location: location,
      p_address: address,
      p_status: status
    })

    if (error) throw error
    return { data, error: null }
  } catch (error) {
    return { data: null, error: normalizeError(error) }
  }
}

export async function getAllProjectsForAdmin() {
  try {
    const { data, error } = await supabase
      .from('projects')
      .select(`
        *,
        developer:profiles!developer_id(
          id,
          full_name,
          company_name,
          email
        ),
        units:units(count)
      `)
      .order('created_at', { ascending: false })

    if (error) throw error
    return { data, error: null }
  } catch (error) {
    return { data: null, error: normalizeError(error) }
  }
}

export async function updateProjectForDeveloper(projectId, updates) {
  try {
    const { data, error } = await supabase
      .from('projects')
      .update(updates)
      .eq('id', projectId)
      .select()
      .single()

    if (error) throw error
    return { data, error: null }
  } catch (error) {
    return { data: null, error: normalizeError(error) }
  }
}

export async function deleteProjectForDeveloper(projectId) {
  try {
    const { error } = await supabase
      .from('projects')
      .delete()
      .eq('id', projectId)

    if (error) throw error
    return { error: null }
  } catch (error) {
    return { error: normalizeError(error) }
  }
}

export async function acceptDeveloperInvitation(token) {
  try {
    const { data, error } = await supabase.rpc('accept_developer_invitation', {
      p_token: token
    })

    if (error) throw error
    return { data, error: null }
  } catch (error) {
    return { data: null, error: normalizeError(error) }
  }
}
